// Smart Markdown Formatting Actions for CodeMirror 6 Mobile

// 1. Task Checkbox Toggle (- [ ] )
export function toggleTaskAction(view) {
  const { state } = view;
  const { from } = state.selection.main;
  const line = state.doc.lineAt(from);
  const lineText = line.text;

  // Task regexes
  const uncheckedMatch = /^(\s*)[-*]\s+\[\s*\]\s*/.exec(lineText);
  const checkedMatch = /^(\s*)[-*]\s+\[[xX]\]\s*/.exec(lineText);

  if (uncheckedMatch) {
    // Already unchecked task -> turn into checked task (- [x] )
    const indent = uncheckedMatch[1];
    const newText = indent + '- [x] ' + lineText.slice(uncheckedMatch[0].length);
    view.dispatch({
      changes: { from: line.from, to: line.to, insert: newText },
      selection: { anchor: line.from + indent.length + 6 }
    });
  } else if (checkedMatch) {
    // Checked task -> strip task prefix
    const indent = checkedMatch[1];
    const newText = indent + lineText.slice(checkedMatch[0].length);
    view.dispatch({
      changes: { from: line.from, to: line.to, insert: newText },
      selection: { anchor: line.from + indent.length }
    });
  } else {
    // Normal line -> prepend - [ ] 
    const match = /^(\s*)/.exec(lineText);
    const indent = match ? match[1] : '';
    const rest = lineText.slice(indent.length);
    const newText = indent + '- [ ] ' + rest;
    view.dispatch({
      changes: { from: line.from, to: line.to, insert: newText },
      selection: { anchor: line.from + indent.length + 6 + (from - line.from - indent.length) }
    });
  }
}

// 2. Heading Toggle (# )
export function toggleHeadingAction(view) {
  const { state } = view;
  const { from } = state.selection.main;
  const line = state.doc.lineAt(from);
  const lineText = line.text;

  const hMatch = /^(\s*)(#+)\s*/.exec(lineText);
  if (!hMatch) {
    // No heading -> add # 
    const match = /^(\s*)/.exec(lineText);
    const indent = match ? match[1] : '';
    const rest = lineText.slice(indent.length);
    view.dispatch({
      changes: { from: line.from, to: line.to, insert: indent + '# ' + rest },
      selection: { anchor: line.from + indent.length + 2 }
    });
  } else {
    const indent = hMatch[1];
    const hashes = hMatch[2];
    const rest = lineText.slice(hMatch[0].length);
    
    if (hashes.length === 1) {
      // # -> ## 
      view.dispatch({ changes: { from: line.from, to: line.to, insert: indent + '## ' + rest } });
    } else if (hashes.length === 2) {
      // ## -> ### 
      view.dispatch({ changes: { from: line.from, to: line.to, insert: indent + '### ' + rest } });
    } else {
      // ### -> remove heading
      view.dispatch({ changes: { from: line.from, to: line.to, insert: indent + rest } });
    }
  }
}

// 3. Math Block Toggle ($$)
export function insertMathBlockAction(view) {
  const { state } = view;
  let { from, to } = state.selection.main;
  const raw = state.sliceDoc(from, to);

  if (from !== to && raw.trim().length > 0) {
    // Text selected -> wrap in $$
    const insert = `$$\n${raw}\n$$`;
    view.dispatch({
      changes: { from, to, insert },
      selection: { anchor: from + 3, head: from + 3 + raw.length }
    });
  } else {
    // No selection -> drop block, place caret inside
    const insert = `$$\n\n$$`;
    view.dispatch({
      changes: { from, to, insert },
      selection: { anchor: from + 3 }
    });
  }
}

// 4. Inline Wrap (code ` or highlight ==)
export function toggleInlineWrapAction(view, marker) {
  const { state } = view;
  const m = marker.length;
  let { from, to } = state.selection.main;

  if (from === to) {
    const word = state.wordAt(from);
    if (word) { from = word.from; to = word.to; }
  }

  const raw = state.sliceDoc(from, to);

  if (raw.length === 0) {
    // Drop empty pair, place caret in middle
    const placeholder = marker === '`' ? 'code' : 'highlight';
    view.dispatch({
      changes: { from, to, insert: marker + placeholder + marker },
      selection: { anchor: from + m, head: from + m + placeholder.length }
    });
    return;
  }

  if (raw.startsWith(marker) && raw.endsWith(marker) && raw.length >= 2 * m) {
    // Toggle off
    const inner = raw.slice(m, raw.length - m);
    view.dispatch({
      changes: { from, to, insert: inner },
      selection: { anchor: from, head: from + inner.length }
    });
    return;
  }

  // Wrap
  view.dispatch({
    changes: { from, to, insert: marker + raw + marker },
    selection: { anchor: from + m, head: from + m + raw.length }
  });
}

// 5. Project Pill Toggle (-> Project)
export function insertProjectPillAction(view) {
  const { state } = view;
  let { from, to } = state.selection.main;
  const raw = state.sliceDoc(from, to);

  if (from !== to && raw.trim().length > 0) {
    const insert = `-> ${raw.trim()}`;
    view.dispatch({
      changes: { from, to, insert },
      selection: { anchor: from + insert.length }
    });
  } else {
    const insert = `-> Project`;
    view.dispatch({
      changes: { from, to, insert },
      selection: { anchor: from + 3, head: from + 10 } // select "Project"
    });
  }
}
